import { render, staticRenderFns } from "./EditDiscountCodeModal.vue?vue&type=template&id=6f8ed7d2"
import script from "./EditDiscountCodeModal.vue?vue&type=script&lang=js"
export * from "./EditDiscountCodeModal.vue?vue&type=script&lang=js"
import style0 from "./EditDiscountCodeModal.vue?vue&type=style&index=0&id=6f8ed7d2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports